import type { HealthInfoZuidoStep } from './healthInfoZuidoTypes';

export function stepQuestionKey(stepId: HealthInfoZuidoStep): string {
  return `submitDocuments.healthInfoZuido.steps.${stepId}`;
}

export function isAgreeChoice(raw: string | undefined | null): boolean {
  const v = raw?.trim().toLowerCase();
  return v === 'yes' || v === 'true';
}

export function conditionsSummaryText(t: (key: string) => string): string {
  return [
    t('submitDocuments.healthInfoZuido.conditionsHeading'),
    '',
    t('submitDocuments.healthInfoZuido.ifAgreeHeading'),
    t('submitDocuments.healthInfoZuido.ifAgree1'),
    t('submitDocuments.healthInfoZuido.ifAgree2'),
    t('submitDocuments.healthInfoZuido.ifAgree3'),
    t('submitDocuments.healthInfoZuido.ifAgree4'),
    '',
    t('submitDocuments.healthInfoZuido.ifDeclineHeading'),
    t('submitDocuments.healthInfoZuido.ifDecline1'),
    t('submitDocuments.healthInfoZuido.ifDecline2'),
    '',
    t('submitDocuments.healthInfoZuido.beforeDecision'),
  ].join('\n');
}

export function formAgreeFollowUpKeys(): string[] {
  return [
    'submitDocuments.healthInfoZuido.formAgreeThankYou',
    'submitDocuments.healthInfoZuido.formAgreeAutoFill',
    'submitDocuments.healthInfoZuido.formAgreePreview',
  ];
}

export function formDeclineFollowUpKeys(): string[] {
  return [
    'submitDocuments.healthInfoZuido.formDeclineThankYou',
    'submitDocuments.healthInfoZuido.formDeclineRecorded',
    'submitDocuments.healthInfoZuido.formDeclineNoSubmit',
  ];
}

export function workHistorySummaryText(t: (key: string) => string): string {
  return [
    t('submitDocuments.healthInfoZuido.workHistory.summaryHeading'),
    t('submitDocuments.healthInfoZuido.workHistory.summary1'),
    t('submitDocuments.healthInfoZuido.workHistory.summary2'),
    t('submitDocuments.healthInfoZuido.workHistory.summary3'),
    t('submitDocuments.healthInfoZuido.workHistory.summary4'),
    t('submitDocuments.healthInfoZuido.workHistory.summary5'),
    t('submitDocuments.healthInfoZuido.workHistory.summary6'),
    t('submitDocuments.healthInfoZuido.workHistory.summary7'),
  ].join('\n');
}

export function workHistoryConfirmYesFollowUpKeys(): string[] {
  return [
    'submitDocuments.healthInfoZuido.workHistory.yesThankYou',
    'submitDocuments.healthInfoZuido.workHistory.yesRecorded',
    'submitDocuments.healthInfoZuido.workHistory.yesFinalized',
  ];
}

export function workHistoryCorrectionFollowUpKeys(): string[] {
  return [
    'submitDocuments.healthInfoZuido.workHistory.correctionThankYou',
    'submitDocuments.healthInfoZuido.workHistory.correctionRecorded',
  ];
}

export const WORK_HISTORY_CORRECTION_CATEGORIES = [
  'personalInfo',
  'workPeriod',
  'workType',
  'worksite',
  'other',
] as const;
